import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "./locales/en/common.json";
import roCommon from "./locales/ro/common.json";
import enPrivacyPolicy from "./locales/en/privacy-policy.json";
import roPrivacyPolicy from "./locales/ro/privacy-policy.json";
import enFooter from "./locales/en/footer.json";
import roFooter from "./locales/ro/footer.json";
import enDashboard from "./locales/en/dashboard.json";
import roDashboard from "./locales/ro/dashboard.json";
import enLanguage from "./locales/en/language.json";
import roLanguage from "./locales/ro/language.json";
import enCurrency from "./locales/en/currency.json";
import roCurrency from "./locales/ro/currency.json";
import enNavigation from "./locales/en/navigation.json";
import roNavigation from "./locales/ro/navigation.json";

const isDev = process.env.NODE_ENV === "development";

const resources = {
  en: {
    common: enCommon,
    "privacy-policy": enPrivacyPolicy,
    footer: enFooter,
    dashboard: enDashboard,
    language: enLanguage,
    currency: enCurrency,
    navigation: enNavigation,
  },
  ro: {
    common: roCommon,
    "privacy-policy": roPrivacyPolicy,
    footer: roFooter,
    dashboard: roDashboard,
    language: roLanguage,
    currency: roCurrency,
    navigation: roNavigation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "ro",
    fallbackLng: "en",
    debug: isDev,

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false,
    },

    load: "languageOnly",
    ns: [
      "common",
      "language",
      "currency",
      "navigation",
      "dashboard",
      "footer",
      "privacy-policy",
    ],
    defaultNS: "common",

    initImmediate: false,
  })
  .catch((error) => {
    if (isDev) {
      console.error("i18n initialization failed:", error);
    }
  });

export default i18n;
